module.exports = __webpack_public_path__ + "img/normalRisk.9671dd4d.png";